export const LOGGER_MESSAGES = {
  PDF_PARSE_ERROR_RESPONSE: 'Failed to parse error response JSON:',
};

